module.exports = __webpack_public_path__ + "static/media/interfaces.468bd753.md";